import { render, staticRenderFns } from "./TopluTakipDurumu.vue?vue&type=template&id=a5d4d556&scoped=true"
import script from "./TopluTakipDurumu.vue?vue&type=script&lang=ts"
export * from "./TopluTakipDurumu.vue?vue&type=script&lang=ts"
import style0 from "./TopluTakipDurumu.vue?vue&type=style&index=0&id=a5d4d556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d4d556",
  null
  
)

export default component.exports